export const RECENTS_STORE_NAME = 'navigation-recents-store';

export const DEFAULT_LOAD_COUNT_RECENT = 5;
export const DEFAULT_LOAD_COUNT_WORKED_ON = 10;
export const DEFAULT_LOAD_COUNT_RECENT_SINGLE_LIST = 20;
